import React from 'react'

function Galleria() {
  return (
    <div className="page page-center">
      <div className="placeholder-card">
        <div className="placeholder-icon" aria-hidden="true">
          <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8"
            strokeLinecap="round" strokeLinejoin="round">
            <path d="M14.5 4h-5L7 7H4a2 2 0 0 0-2 2v9a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2V9a2 2 0 0 0-2-2h-3l-2.5-3z" />
            <circle cx="12" cy="13" r="3" />
          </svg>
        </div>
        <h1>Galleria</h1>
        <p>Coming soon...</p>
      </div>
    </div>
  )
}

export default Galleria
